export default __webpack_public_path__ + "media/images/5-dogs-047066c9886ea01ee5f687a1d4ede829.png";